import { DataAccess } from "../dataaccess/data.access";
import { Event } from "../pojo/Event";
import { S25Util } from "../util/s25-util";
import Occurrence = Event.Occurrence;

export type DateTemplateRecord = {
    profile_id: number;
    profile_name: string;
    profile_code?: string;
    init_start_dt: string;
    init_end_dt: string;
    setup_tm?: string;
    tdown_tm?: string;
    adhoc?: { start_dt: string; end_dt: string }[];
};

export class DateTemplateService {
    public static async getTemplates(): Promise<DateTemplateRecord[]> {
        const data = await DataAccess.get(
            DataAccess.injectCaller("/date/template/get.json", "DateTemplateService.getTemplates"),
        );
        return (data?.templates?.template ?? []) as DateTemplateRecord[];
    }

    public static async saveTemplate(
        profileId: number | null,
        profileName: string,
        profileCode: string,
        recTypeId: number,
        occurrences: Occurrence[],
        initStartDt: Date,
        initEndDt: Date,
    ): Promise<number> {
        const minutes = occurrences?.length ? occurrences[0].minutes : undefined;
        const setupMinutes = minutes?.setupMinutes ?? 0;
        const takedownMinutes = minutes?.takedownMinutes ?? 0;
        const setupRelDt = S25Util.date.parse("1900-01-01T00:00:00");
        const setupDt = setupMinutes > 0 ? S25Util.date.addMinutes(setupRelDt, setupMinutes) : "";
        const takedownDt = takedownMinutes > 0 ? S25Util.date.addMinutes(setupRelDt, takedownMinutes) : "";

        const response = await DataAccess.put(
            DataAccess.injectCaller("/date/template/set.json", "DateTemplateService.saveTemplate"),
            {
                root: {
                    profileId: profileId ?? "",
                    profileName: profileName ?? "",
                    profileCode: profileCode ?? "",
                    recTypeId: S25Util.coalesce(recTypeId, ""),
                    occurrences:
                        recTypeId === 1
                            ? occurrences.map((occurrence) => ({
                                  startDt: S25Util.date.toS25ISODateTimeStr(occurrence.evStartDt),
                                  endDt: S25Util.date.toS25ISODateTimeStr(occurrence.evEndDt),
                              }))
                            : "",
                    setupTm: setupDt ? S25Util.date.toS25ISODateTimeStr(setupDt as Date) : "",
                    tdownTm: takedownDt ? S25Util.date.toS25ISODateTimeStr(takedownDt as Date) : "",
                    initStartDt: S25Util.date.toS25ISODateTimeStr(initStartDt) ?? "",
                    initEndDt: S25Util.date.toS25ISODateTimeStr(initEndDt) ?? "",
                },
            },
        );
        return S25Util.toInt(S25Util.propertyGetVal(response, "profileId"));
    }

    public static deleteTemplate(profileId: number): Promise<unknown> {
        return DataAccess.delete(
            DataAccess.injectCaller(
                `/date/template/delete.json?profile_id=${profileId}`,
                "DateTemplateService.deleteTemplate",
            ),
        );
    }
}
